import React, { FC } from 'react';
import { HeaderLogo } from './logo/HeaderLogo';
import { HeaderDoctrineLogo } from './HeaderDoctrineLogo';

type Props = {
  loggedIn: boolean;
  hideLogoTitle: boolean;
  source: string;
};

export const HeaderContentLogo: FC<Props> = ({
  loggedIn,
  hideLogoTitle,
  source,
}) => (
  <HeaderLogo source={source} loggedIn={loggedIn}>
    <HeaderDoctrineLogo hideLogoTitle={hideLogoTitle} />
  </HeaderLogo>
);
